<script>
  import NotterWebp from '../assets/promos/notter.webp'
  import HoppmesterenWebp from '../assets/promos/hoppmesteren.webp'
  import LydenAvJulWebp from '../assets/promos/lydenavjul.webp'
  import JulPaTvWebp from '../assets/promos/julpatv.webp'

  const campaignparams = '?utm_source=julemimre&utm_medium=promos&utm_campaign=viderenavigasjon-jul'

  const promos = [
    {
      brand: 'nrkno',
      image: NotterWebp,
      imageAlt: 'Julenøtter på nrk.no',
      kicker: 'Julenøtter digitalt på nrk.no',
      title: 'Løs julenøtter i romjula',
      text: 'Bryn deg på julenøtter sammen med hele familien!',
      href: 'https://delta.nrk.no/julenotter/?utm_source=nrkno&utm_medium=julemimre&utm_campaign=julenotter',
    },
    {
      brand: 'nrkno',
      image: HoppmesterenWebp,
      imageAlt: 'Julemimre på nrk.no',
      kicker: 'Spill på nrk.no',
      title: 'Unngå skinnfellen og skål med grevinnen',
      text: 'Spill Grevinnen og HOPPmesteren',
      href: 'https://www.nrk.no/grevinnen-og-hoppmesteren-spillet-_-prov-deg-som-hovmesteren-1.15781813',
    },
    {
      brand: 'nrkradio',
      image: LydenAvJulWebp,
      imageAlt: 'Lyden av jul i NRK Radio',
      kicker: 'Hør i NRK Radio',
      title: 'Trenger du julestemning?',
      text: 'Velkommen inn i NRK Radio sitt juleunivers',
      href: 'https://radio.nrk.no/kategori/jul',
    },
    {
      brand: 'nrktv',
      image: JulPaTvWebp,
      imageAlt: 'Juleprogrammer i NRK TV',
      kicker: 'Se i NRK TV',
      title: 'Julens klassikere og nye tradisjoner',
      text: 'Finn dine favoritter i NRK TV',
      href: 'https://tv.nrk.no/programmer/jul',
    },
  ]
</script>

<div class="promos">
  <h2>Oppdag mer juleinnhold</h2>
  <ul>
    {#each promos as promo}
      <li class="promo">
        <a href="{promo.href}{campaignparams}">
          <div class={`promo-image brand-${promo.brand}`}>
            <img src={promo.image} alt={promo.imageAlt} loading="lazy" width="1200" height="675" />
          </div>
          <div class="promo-text">
            <span class="promo-kicker">{promo.kicker}</span>
            <h3>{promo.title}</h3>
            <p>{promo.text}</p>
          </div>
        </a>
      </li>
    {/each}
  </ul>
</div>

<style>
  .promos {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 600px;
  }

  .promos ul {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    list-style: none;
    padding: 0;
  }

  .promo {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 1rem;
  }

  .promo-image {
    position: relative;
    z-index: 0;
  }

  .promo-image.brand-nrkno:after {
    background: no-repeat center/100% url('../assets/brands/nrkno.png');
  }

  .promo-image.brand-nrkradio:after {
    background: no-repeat center/100% url('../assets/brands/nrkradio.png');
  }

  .promo-image.brand-nrktv:after {
    background: no-repeat center/100% url('../assets/brands/nrktv.png');
  }

  .promo-image:after {
    content: '';
    position: absolute;
    width: 42px;
    height: 42px;

    bottom: 1em;
    right: 1em;
    z-index: 2;
  }

  .promo-image img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .promo a {
    margin: 0.5rem 0 1rem 0;
    text-decoration: none;
  }

  .promo a:hover h3,
  .promo a:hover p {
    text-decoration: underline;
  }

  .promo-kicker {
    background-color: #b2cff5;
    color: #0c366c;
    border-radius: 2px;
    padding: 0.2em 0.5em;
    font-weight: 700;
  }

  .promo h3 {
    font-size: 22px;
    margin: 14px 0 0 0;
  }

  .promo p {
    margin: 3px 0 0 0;
  }

  .promo-text {
    padding: 1rem;
    background-color: #0c366c;
    color: #fff;
    border-radius: 0px 0px 3px 3px;
  }
</style>
